import { createAction, props } from '@ngrx/store';
import { Product } from '../_models';

// Action types
export const loadProducts = createAction('[Product] Load Products');
export const loadProductsSuccess = createAction(
  '[Product] Load Products Success',
  props<{ products: Product[] }>()
);
export const loadProductsFailure = createAction(
  '[Product] Load Products Failure',
  props<{ error: any }>()
);

export const addProduct = createAction('[Product] Add Product', props<{ product: Product }>());
export const addProductSuccess = createAction(
  '[Product] Add Product Success',
  props<{ product: Product }>()
);
export const addProductFailure = createAction(
  '[Product] Add Product Failure',
  props<{ error: any }>()
);

export const updateProduct = createAction(
  '[Product] Update Product',
  props<{ product: Product }>()
);
export const updateProductSuccess = createAction(
  '[Product] Update Product Success',
  props<{ product: Product }>()
);
export const updateProductFailure = createAction(
  '[Product] Update Product Failure',
  props<{ error: any }>()
);

export const deleteProduct = createAction('[Product] Delete Product', props<{ id: number }>());
export const deleteProductSuccess = createAction(
  '[Product] Delete Product Success',
  props<{ id: number }>()
);
export const deleteProductFailure = createAction(
  '[Product] Delete Product Failure',
  props<{ error: any }>()
);

export const fetchProduct = createAction(
  '[Product] Fetch Product',
  props<{ productId: number; isSelectable?: boolean }>()
);
export const fetchProductSuccess = createAction(
  '[Product] Fetch Product Success',
  props<{ product: Product; isSelectable?: boolean }>()
);
export const fetchProductFailure = createAction(
  '[Product] Fetch Product Failure',
  props<{ error: any }>()
);

export const fetchProductsByIds = createAction(
  '[Product] Fetch Products By IDs',
  props<{ productIds: number[]; isSelectable?: boolean }>()
);
export const fetchProductsByIdsSuccess = createAction(
  '[Product] Fetch Products By IDs Success',
  props<{ products: Product[]; isSelectable?: boolean }>()
);
export const fetchProductsByIdsFailure = createAction(
  '[Product] Fetch Products By IDs Failure',
  props<{ error: any }>()
);
